import { render, staticRenderFns } from "./Dice.vue?vue&type=template&id=2e4afa6e&scoped=true&"
import script from "./Dice.vue?vue&type=script&lang=js&"
export * from "./Dice.vue?vue&type=script&lang=js&"
import style0 from "./Dice.vue?vue&type=style&index=0&id=2e4afa6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4afa6e",
  null
  
)

export default component.exports